const mapOrigin = {
  pay: 'pay',
  request: 'request',
  qbmIntegration: 'qbm',
  qbrIntegration: 'qbr',
  qboIntegration: 'qbo',
  qbrIos: 'qbr-ios',
  qbrAndroid: 'qbr-android',
  accounts: 'partners',
  accountsPayablePlatform: 'partners'
};

export { mapOrigin };
